import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './nutricao.css';

const Nutricao = () => {
    const [dailyContent, setDailyContent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDailyContent = async () => {
            try {
                const userIdentifier = localStorage.getItem('userEmail');
                const token = localStorage.getItem('token');
                
                if (!userIdentifier) {
                    throw new Error('Usuário não identificado. Faça login novamente.');
                }
                
                const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
                const response = await axios.get(`${apiUrl}/api/cronogramas/dia/${userIdentifier}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                setDailyContent(response.data);
                setLoading(false);
            } catch (err) {
                console.error('Erro ao buscar conteúdo nutricional:', err);
                setError(err);
                setLoading(false);
            }
        };

        fetchDailyContent();
    }, []);

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>Erro ao carregar conteúdo nutricional</div>;

    const nutricao = dailyContent?.nutricao || {};

    return (
        <div className="nutricao">

            <div className="CardNutricao">
                <div className='nutri'>
                <h2>Dieta do Dia</h2>
                <p>{new Date().toLocaleDateString()}</p>
                </div>

                <div className="meal-section">
                    <h2 className="meal-title">Café da Manhã</h2>
                    <p className="meal-time">Horário: 07:00</p>
                    <ul className="meal-items">
                        <li>{nutricao.cafeDaManha || 'Sem informações de café da manhã'}</li>
                    </ul>
                </div>

                <div className="meal-section">
                    <h2 className="meal-title">Almoço</h2>
                    <p className="meal-time">Horário: 12:30</p>
                    <ul className="meal-items">
                        <li>{nutricao.almoco || 'Sem informações de almoço'}</li>
                    </ul>
                </div>

                <div className="meal-section">
                    <h2 className="meal-title">Lanche da Tarde</h2>
                    <p className="meal-time">Horário: 16:00</p>
                    <ul className="meal-items">
                        <li>{nutricao.lancheDaTarde || 'Sem informações de lanche da tarde'}</li>
                    </ul>
                </div>

                <div className="meal-section">
                    <h2 className="meal-title">Jantar</h2>
                    <p className="meal-time">Horário: 19:30</p>
                    <ul className="meal-items">
                        <li>{nutricao.jantar || 'Sem informações de jantar'}</li>
                    </ul>
                </div>

            </div>   
        </div>
    );
};

export default Nutricao;
